export const typeOfHeatmapSettingsDialog = 'typeOfHeatmapSettingsDialog';

export const REDUCER_KEY_HEATMAP_SETTINGS_DIALOG = 'HeatmapSettingsDialog';
export const FETCH_SETTINGS = 'HeatmapSettingsDialog/FETCH_SETTINGS';
export const FETCH_SETTINGS_SUCCESS = 'HeatmapSettingsDialog/FETCH_SETTINGS_SUCCESS';
export const FETCH_SETTINGS_ERROR = 'HeatmapSettingsDialog/FETCH_SETTINGS_ERROR';

// For AA tracking
export const AA_CACHED_HEATMAP_KEY = 'AA_CACHED_HEATMAP_KEY';

export const DEFAULT_PRESET_SETTINGS = {
  showPopup: true,
  startInFullScreen: true,
  showSubstances: 'drawing',
};

export const cellOperationOptionsMapping = {
  MAX: 'Maximum of pX',
  MIN: 'Minimum of pX',
  AVERAGE: 'Average of pX',
  MEDIAN: 'Median of pX',
};

export const showSubstancesOptionsMapping = {
  names: 'Names',
  drawing: 'Structure drawing',
};
